export const removeBackButton = (config) => {
    const { annotations } = config;

    const annotationsWithNoBackButton = annotations.filter((annotation) => {
        return annotation.toolType !== 'quizBack';
    })

    return {
        ...config,
        annotations: annotationsWithNoBackButton
    };
};